module.exports = __webpack_public_path__ + "img/marker_two_yellow3.b171755d.png";